import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useSearchParams } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Contact from "./components/Contact";
import Works from "./components/Works";
import Privacy from "./components/Privacy";
import "./App.css";
import translations from "./translations";

function useTheme() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("kleos-theme") || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("kleos-theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === "dark" ? "light" : "dark");
  return [theme, toggleTheme];
}

function HomePage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [lang, setLang] = useState(searchParams.get("lang") || "el");
  const [theme, toggleTheme] = useTheme();
  const t = translations[lang];

  useEffect(() => {
    setSearchParams({ lang });
  }, [lang, setSearchParams]);

  return (
    <>
      <Navbar lang={lang} setLang={setLang} t={t} isHomePage={true} theme={theme} toggleTheme={toggleTheme}/>
      <Hero t={t}/>
      <Services t={t}/>
      <Works t={t} lang={lang}/>
      <About t={t} lang={lang}/>
      <Contact t={t}/>
      <footer style={footerStyle}>
        <div style={{ opacity: 0.4, fontSize: "0.8rem", marginBottom: "0.5rem" }}>Αρ. ΓΕ.ΜΗ. : 185793531000 &nbsp;|&nbsp; +30 24410 25110 &nbsp;|&nbsp; info@kleos-ai.gr</div>
        <div style={{ color: "var(--text-muted)", fontSize: "0.82rem" }}>© 2025 KLEOS AI. All rights reserved.</div>
        <a href={`/privacy?lang=${lang}`} style={{ color: "var(--accent-blue)", fontSize: "0.82rem", marginTop: "0.4rem", display: "inline-block" }}>{t.privacy}</a>
      </footer>
    </>
  );
}

function PrivacyPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [lang, setLang] = useState(searchParams.get("lang") || "el");
  const [theme, toggleTheme] = useTheme();
  const t = translations[lang];

  useEffect(() => {
    setSearchParams({ lang });
  }, [lang, setSearchParams]);

  return (
    <>
      <Navbar lang={lang} setLang={setLang} t={t} isHomePage={false} theme={theme} toggleTheme={toggleTheme}/>
      <Privacy t={t}/>
      <footer style={footerStyle}>
        <div style={{ opacity: 0.4, fontSize: "0.8rem", marginBottom: "0.5rem" }}>Αρ. ΓΕ.ΜΗ. : 185793531000 &nbsp;|&nbsp; +30 24410 25110 &nbsp;|&nbsp; info@kleos-ai.gr</div>
        <div style={{ color: "var(--text-muted)", fontSize: "0.82rem" }}>© 2025 KLEOS AI. All rights reserved.</div>
        <a href={`/?lang=${lang}`} style={{ color: "var(--accent-blue)", fontSize: "0.82rem", marginTop: "0.4rem", display: "inline-block" }}>{lang === "el" ? "← Αρχική" : "← Home"}</a>
      </footer>
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
    </Router>
  );
}

const footerStyle = {
  textAlign: "center",
  padding: "2.5rem 2rem",
  background: "var(--bg-secondary)",
  borderTop: "1px solid var(--border)",
  color: "var(--text-secondary)",
  fontSize: "0.9rem"
};

export default App;
